/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-02-04 17:14:48
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-19 14:35:11
 */
import Vue from 'vue'
import SvgIcon from '@/components/common/SvgIcon'// svg组件
// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)
